import React from 'react'
import { connect } from 'react-redux';
import SortingHeader from './SortingHeader';
import Item from './Item';
import CompanyModel from '/app/src/model/Company/model'
import CompanySelector from '/app/src/model/Company/selector'
import { Spinner, Flex } from '/app/src/component'
import Pagination from '/app/src/component/Pagination'
import { withRouter } from 'react-router-dom'

class DashboardHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: props.currentPage,
            tickets: props.tickets,
            count: props.count
        };

        this._renderTicketList = this._renderTicketList.bind(this)
        this._onPaginationClick = this._onPaginationClick.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(CompanyModel.readHistoryPage(this.state.currentPage))
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            tickets: nextProps.tickets,
            count: nextProps.count
        })
    }

    _renderTicketList() {
        if (this.props.isFetching && !this.state.tickets.size) {
            return (
                <Flex key='is-fetching' center>
                    <Spinner text='Hämtar avklarade ärenden' />
                </Flex>)
        }
        if (this.state.tickets.size) {
            return this.state.tickets.map((ticket, index) =>
                <Item key={index} ticket={ticket} />
            )
        }
        return (
            <Flex column grow center>
                Det finns inga tidigare ärenden
            </Flex>
        )
    }
    _onPaginationClick(index) {
        this.props.dispatch(CompanyModel.readHistoryPage(index))
        this.setState({ currentPage: index })
    }

    render() {
        return (
            <Flex column grow w='100%' overflow='auto'>
                <SortingHeader />
                <Flex w='100%' h='100%' column grow overflow='auto' paddingRight='10px'>
                    {this._renderTicketList()}
                </Flex>
                <Flex center basis='59px' w='100%'
                    borderTop='1px solid lightgrey'
                    shrink={0}
                >
                    <Pagination marginTop='auto'
                        itemCounts={this.state.count}
                        itemPerPage={10}
                        currentPage={this.state.currentPage}
                        onClick={this._onPaginationClick}
                    />
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state) {
    const history = CompanySelector.getHistory(state)

    return {
        tickets: CompanySelector.getCurrentPageTickets(state),
        isFetching: history.get('isFetching'),
        count: history.get('count'),
        currentPage: history.get('currentPage')
    };
}

export default connect(mapStateToProps)(withRouter(DashboardHistory));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/History/index.js